import {
  GET_TENANTS,
  GET_TENANTS_ERROR,
  TENANTS_LOADING,
  SAVE_TENANT,
  DELETE_TENANT,
  TENANT_REPORT,
  TENANT_REPORT_LOADING,
  TENANT_REPORT_ERROR,
} from "../actions/types";

const initialState = {
  // For admins: every tenant, and every kiosk as { _id, name, location }
  tenants: [],
  printers: [],
  loading: true,
  // For a tenant: their report (GET /api/monitoring/tenant-report) and when it
  // was loaded. The last one stays while the next loads.
  report: null,
  updatedAt: null,
  reportLoading: false,
  reportError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_TENANTS:
      return {
        ...state,
        loading: false,
        tenants: payload.tenants,
        printers: payload.printers,
      };
    case GET_TENANTS_ERROR:
      return {
        ...state,
        loading: false,
      };
    case TENANTS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SAVE_TENANT: {
      const known = state.tenants.some((item) => item._id === payload._id);
      return {
        ...state,
        tenants: known
          ? state.tenants.map((item) => (item._id === payload._id ? payload : item))
          : [...state.tenants, payload],
      };
    }
    case DELETE_TENANT:
      return {
        ...state,
        tenants: state.tenants.filter((item) => item._id !== payload),
      };
    case TENANT_REPORT_LOADING:
      return {
        ...state,
        reportLoading: true,
        reportError: false,
      };
    case TENANT_REPORT:
      return {
        ...state,
        reportLoading: false,
        report: payload.report,
        updatedAt: payload.updatedAt,
      };
    case TENANT_REPORT_ERROR:
      return {
        ...state,
        reportLoading: false,
        reportError: true,
      };
    default:
      return state;
  }
}
